import { render, staticRenderFns } from "./newHelpDocument.vue?vue&type=template&id=9ffe829e&scoped=true&"
import script from "./newHelpDocument.vue?vue&type=script&lang=js&"
export * from "./newHelpDocument.vue?vue&type=script&lang=js&"
import style0 from "./newHelpDocument.vue?vue&type=style&index=0&id=9ffe829e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ffe829e",
  null
  
)

export default component.exports